/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useHistory, useLocation } from 'react-router';
import { LuisSidebar } from 'src/core/components/LuisSidebar';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { LuisSidebarItemProps } from 'src/core/types/luisSidebar';
import { routeTable } from 'src/core/utils/routeTable';
import { doesRouteMatchLocation } from 'src/core/utils/routingUtils';

const messages = defineMessages({
    jobCreation: { id: 'translation.translationSidebar.jobCreation', defaultMessage: 'Job creation' },
    history: { id: 'translation.translationSidebar.history', defaultMessage: 'Job history' },
    settings: { id: 'translation.translationSidebar.settings', defaultMessage: 'Translation settings' }
});

export const TranslationSidebar = () => {
    const history = useHistory();
    const { pathname } = useLocation();
    const { localize } = useLocalization();
    const routes = routeTable.translation;

    const items: LuisSidebarItemProps[] = [
        {
            iconName: 'Home',
            text: 'Language Studio',
            onClick: () => history.push(routeTable.languageStudio.root()),
            isSelected: doesRouteMatchLocation(routeTable.languageStudio.root(), { exact: true, locationToMatch: pathname })
        },
        {
            iconName: 'DocumentSet',
            text: localize(messages.jobCreation),
            isSelected: doesRouteMatchLocation(routes.root(), { exact: true, locationToMatch: pathname }),
            onClick: () => history.push(routes.root())
        },
        {
            iconName: 'TaskManager',
            text: localize(messages.history),
            isSelected: doesRouteMatchLocation(routes.documentTranslationHistory(), { exact: true, locationToMatch: pathname }),
            onClick: () => history.push(routes.documentTranslationHistory())
        },
        {
            iconName: 'Settings',
            text: localize(messages.settings),
            isSelected: doesRouteMatchLocation(routes.documentTranslationSettings(), { exact: true, locationToMatch: pathname }),
            onClick: () => history.push(routes.documentTranslationSettings())
        }
    ];

    return <LuisSidebar itemLists={[items]} />;
};
